import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { AdvertisingCampaignRemunerationDetails } from "src/app/shared/models/advertising-campaigns/advertisingCampaignRemunerationDetails.interface";
import { UpdatePaymentLP } from "src/app/shared/models/update-payment-LP.interface";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeUpdatePaymentStatusLP } from "src/app/store/locationPartner/location-partner.action";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { catchForbiddenErrorSelector } from "src/app/store/user/user.selectors";

@Component({
  selector: "app-update-payment-status",
  templateUrl: "./update-payment-status.component.html",
})
export class UpdatePaymentStatusComponent extends BaseComponent implements OnInit {
  @Input() title: string;
  @Input() companyName: string;
  @Input() advertisingCampaigns: AdvertisingCampaignRemunerationDetails[];
  @Input() dateRange: Date[];
  @Input() isPaid: boolean;
  @Input() companyNameFilter: string;
  updatePaymentStatusLP: UpdatePaymentLP = {
    companyName: "",
    advertisingCampaign: [],
  };
  campaignsHashedId: string[] = [];
  catchForbiddenError$: Observable<boolean | null>;

  loading : boolean
  constructor(
    private modalService: NgbModal,
    private store: Store<AppStateInterface>
  ) {
    super(store)
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.modalService.dismissAll();
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.advertisingCampaigns?.map((e) => {
      this.campaignsHashedId = [
        ...this.campaignsHashedId,
        e.hashedId,
      ];
    });
  }
  onClickDismissAll() {
    this.modalService.dismissAll();
  }
  onChangeSave(event: any, title: string) {
    if (event.target.checked) {
      this.campaignsHashedId = [...this.campaignsHashedId, title];
    } else {
      this.campaignsHashedId = this.campaignsHashedId.filter(
        (currentTitle) => currentTitle !== title
      );
    }
  }
  onClickUpdatePaymentStatus() {
    this.loading = true
    this.updatePaymentStatusLP = {
      companyName: this.companyName,
      advertisingCampaign: [...new Set(this.campaignsHashedId)],
    };
    if (this.dateRange != null) {
      this.store.dispatch(
        invokeUpdatePaymentStatusLP({
          updatePaymentStatusLP: this.updatePaymentStatusLP,
        })
      );
    }
  }
}
